export var ALL = 0;
export var TRACE = 0;
export var DEBUG = 1;
export var INFO = 2;
export var WARN = 3;
export var ERROR = 4;
export var FATAL = 5;
export var OFF = 6;